import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{
    minHeight: '60vh',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    padding: '64px 24px', textAlign: 'center',
  }}>
    <div style={{
      fontFamily: 'var(--font-serif)', fontSize: '64px', fontWeight: 500,
      color: 'var(--surface-cream-strong)', letterSpacing: '-2px', lineHeight: 1,
      marginBottom: '16px',
    }}>
      404
    </div>
    <h1 style={{
      fontFamily: 'var(--font-serif)', fontSize: '28px', fontWeight: 500,
      color: 'var(--ink)', letterSpacing: '-0.5px', margin: '0 0 8px',
    }}>
      Page not found
    </h1>
    <p style={{
      fontFamily: 'var(--font-sans)', fontSize: '14px', color: 'var(--muted)',
      margin: '0 0 24px', maxWidth: '380px', lineHeight: 1.55,
    }}>
      The page you are looking for does not exist or may have moved.
    </p>
    <Link to="/on/dashboard" className="btn-primary" style={{ textDecoration: 'none' }}>
      Go to Dashboard
    </Link>
  </div>
);

export default NotFound;
